import React from 'react';

const Ogolne = (props) => {
  return (
    <React.Fragment>
      <h5 className="page-header firstColor">
        <b>Grupowe Ubezpieczenie TUW PZUW Opieka Medyczna</b> to profesjonalna{' '}
        <b>opieka medyczna</b>, <br />w renomowanych placówkach medycznych w
        całej Polsce dla współpracowników TVP, byłych pracowników TVP oraz
        członków ich rodzin.
      </h5>

      <div className="row">
        <div className="col-sm-6 secondColor">
          <b className="firstColor">
            W ramach Pakietów Medycznych TUW PZUW otrzymujesz:
          </b>
          <ul className="listIcons okCircle mt-3">
            <li>
              wizyty u wykwalifikowanych specjalistów <b>bez skierowań</b>
            </li>
            <li>
              dostęp do szerokiego katalogu <b>specjalizacji</b>, badań i
              zabiegów, również na podstawie skierowania wystawionego poza
              siecią PZU
            </li>
            <li>
              <b>gwarancję krótkiego terminu</b> realizacji wizyty:
              <ul className="listIcons ok">
                <li>
                  u <b>lekarza POZ</b> (internista, lekarz rodzinny, pediatra){' '}
                  maksymalnie <b>2 dni robocze</b>
                </li>
                <li>
                  u <b>specjalisty</b> – do <b>5 dni roboczych</b>*
                </li>
              </ul>
            </li>
            <li>
              dostęp do <b>telekonsultacji medycznych</b> nawet do 24
              specjalizacji, również podczas przebywania poza granicami Polski
            </li>
          </ul>

          <b className="firstColor">
            Wiek uprawniający do objęcia ubezpieczeniem:
          </b>
          <ul className="listUnstyled">
            <li>
              <b>Współpracownik/były pracownik</b> oraz <b>małżonek/partner</b>{' '}
              – do ukończenia 67 roku życia
            </li>
            <li>
              <b>Dzieci</b> – do ukończenia 26 roku życia
            </li>
            <li>
              <b>Dorosłe dziecko</b> – dla dzieci, które ukończyły 26 rok życia,
              a nie ukończyły 67 roku życia
            </li>
            <li>
              <b>Senior</b> – dla rodziców/teściów współpracownika, którzy nie
              ukończyli 80 roku życia, oraz dla współpracowników i byłych
              pracowników pow. 67 r.ż. – do ukończenia 80 r.ż.
            </li>
          </ul>
        </div>

        <div className="col-sm-6 secondColor">
          <b className="firstColor">
            Masz możliwość wyboru wariantu opieki w ramach dostępnych pakietów i
            zakresów:
          </b>
          <br />
          <br />

          <b>Zakresy</b>
          <ul className="dashedList">
            <li>Standard</li>
            <li>Komfort</li>
            <li>Komfort Plus</li>
            <li>Optimum</li>
          </ul>

          <b>Rodzaje pakietów</b>
          <ol>
            <li>
              <b>Pakiet indywidualny</b> – dla współpracownika/byłego pracownika
            </li>
            <li>
              <b>Pakiet partnerski</b> – dla współpracownika/byłego pracownika i
              jednego członka najbliższej rodziny (małżonka/partnera lub
              dziecka)
            </li>
            <li>
              <b>Pakiet rodzinny</b> – dla współpracownika/byłego pracownika
              oraz członków najbliższej rodziny (małżonka/partnera i dzieci)
              <br />
              <span style={{ display: 'block', marginTop: '8px' }}>
                Członkowie rodziny w pakiecie partnerskim i rodzinnym{' '}
                <b>objęci są tym samym zakresem</b> co współpracownik/były
                pracownik.
              </span>
            </li>
            <li>
              <b>Pakiet Dorosłe Dziecko</b> – dostępny zakres <b>Komfort</b>
            </li>
            <li>
              <b>Pakiet Senior</b> – dostępny zakres <b>Komfort</b>
            </li>
          </ol>
        </div>
      </div>

      <p className="small mt-3 text-justify secondColor">
        *Wskazane terminy dostępności obowiązują po uprzednim umówieniu
        konsultacji poprzez infolinię (opłata zgodna z taryfą operatora),
        zgodnie z przysługującym zakresem ubezpieczenia oraz we wskazanej przez
        TUW PZUW placówce medycznej. Wskazane terminy nie dotyczą okresu
        obowiązywania stanu epidemii, pandemii lub innych sytuacji
        uniemożliwiających tradycyjne przyjęcia pacjentów.
      </p>

      <br />
      <div className="text-white p-2 sixthColor iconFromLeft moneyIcon">
        <h5 className="firstColor">
          <b>Składka za ubezpieczenie (opłata za miesiąc)</b>
        </h5>
      </div>

      <br />
      <table className="table table-striped table-condensed secondColor">
        <tbody>
          <tr>
            <th className="text-center">Zakres / Pakiet</th>
            <th className="text-center">Standard</th>
            <th className="text-center">Komfort</th>
            <th className="text-center">Komfort Plus</th>
            <th className="text-center">Optimum</th>
          </tr>
          <tr>
            <th className="text-center">Indywidualny</th>
            <td className="text-center">197,00 zł</td>
            <td className="text-center">385,50 zł</td>
            <td className="text-center">445,10 zł</td>
            <td className="text-center">913,70 zł</td>
          </tr>
          <tr>
            <th className="text-center">
              Partnerski
              <br />
              {/* <small>(dopłata do pakietu indywidualnego)</small> */}
            </th>
            <td className="text-center">408,00 zł</td>
            <td className="text-center">797,90 zł</td>
            <td className="text-center">890,10 zł</td>
            <td className="text-center">1 847,60 zł</td>
          </tr>
          <tr>
            <th className="text-center">
              Rodzinny
              <br />
              {/* <small>(dopłata do pakietu indywidualnego)</small> */}
            </th>
            <td className="text-center">621,00 zł</td>
            <td className="text-center">1 214,10 zł</td>
            <td className="text-center">1 483,30 zł</td>
            <td className="text-center">3 044,70 zł</td>
          </tr>
          <tr>
            <th className="text-center">Senior</th>
            <td className="text-center">-</td>

            <td className="text-center">385,50 zł</td>
            <td className="text-center">-</td>
            <td className="text-center">-</td>
          </tr>
          <tr>
            <th className="text-center">Dorosłe dziecko</th>
            <td className="text-center">-</td>
            <td className="text-center">385,50 zł</td>
            <td className="text-center">-</td>
            <td className="text-center">-</td>
          </tr>
        </tbody>
      </table>

      <p className="secondColor">
        Składka za ubezpieczenie współpracownika/byłego pracownika płatna jest
        na numer rachunku wskazany w deklaracji przystąpienia do ubezpieczenia.
      </p>
      <p className="secondColor">
        Członek najbliższej rodziny (małżonek/partner/dzieci do 26 r.ż.) objęty
        jest takim samym zakresem ubezpieczenia co pracownik.
      </p>
    </React.Fragment>
  );
};

export default Ogolne;
